<dx-toolbar>
  <dxi-toolbar-item location="before"
    ><span [class]="titleClass">{{ 'common.detalle' | translate }}</span>
  </dxi-toolbar-item>
  <dxi-toolbar-item location="after" locateInMenu="auto" [visible]="!isEditing">
    <dx-button
      [text]="'common.editar' | translate"
      icon="edit"
      stylingMode="contained"
      type="default"
      (onClick)="handleEditClick()"
    ></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item location="after" locateInMenu="auto" [visible]="isEditing">
    <dx-button
      [text]="'common.guardar' | translate"
      stylingMode="contained"
      type="default"
      (onClick)="handleSaveButtonClick($event)"
    ></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item location="after" locateInMenu="auto" [visible]="isEditing">
    <dx-button
      [text]="'common.cancelar' | translate"
      (onClick)="handleCancelEditClick()"
      stylingMode="outlined"
      type="normal"
    ></dx-button>
  </dxi-toolbar-item>
</dx-toolbar>
